module.exports = __webpack_public_path__ + "neye_icon.svg";